import React from "react";
import {MERCHANT_NOTIFICATIONS} from "../../components/notificationScope";
import {CabinetNotificationsPage} from "../CabinetNotificationsPage";

/** Вся история уведомлений мерчанта. */
export function MerchantNotificationsPage(): JSX.Element {
  return <CabinetNotificationsPage scope={MERCHANT_NOTIFICATIONS} className="merchant-page"/>;
}
